package api.dataclasses.inbound

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class InboundReceiptLine (
    @SerialName("Regelnummer") val recordId: Int,
    @SerialName("Ontvangst") val receipt: Int,
    @SerialName("Artikel") val article: String,
    @SerialName("Artikelnummer") val articleNumber: String?,
    @SerialName("Artikel omschrijving") val articleDescription: String?,
    @SerialName("Artikelgroep") val articleCategory: String?,
    @SerialName("Kleur omschrijving") val colorDescription: String?,
    @SerialName("Maatcode") val sizeCode: String?,
    @SerialName("Reden") val reason: String?,
    @SerialName("Retourreden") val returnReason: String?,
    @SerialName("Statusomschrijving") val statusDescription: String?,
    @SerialName("Aantal ontvangen") val amountReceived: Double?,
    @SerialName("Aantal verwacht") val amountExpected: Double?,
)